import StaticPageLayout from "./StaticPageLayout";

const RefundCancellationPolicy = () => {
  return (
    <StaticPageLayout
      title="Refund & Cancellation Policy"
      subtitle="This policy explains when cancellations and refunds are available for Sundarban Cargo Services UK Limited and how refunds are processed."
      lastUpdated="January 2026"
    >
      <div className="bg-white rounded-2xl border border-gray-200 p-6 sm:p-10 space-y-10">
        <section>
          <h2 className="text-2xl font-semibold text-gray-900">Cancellations</h2>
          <ul className="mt-4 list-disc pl-6 text-gray-700 space-y-2">
            <li>
              Cancellations are allowed <strong>only before pickup</strong> (or before the shipment is collected or
              dispatched).
            </li>
            <li>
              Once a shipment has been collected, dispatched, handed to a carrier, or entered into processing, the
              booking cannot be cancelled.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-900">Refund Eligibility</h2>
          <p className="mt-3 text-gray-700">Refunds may be considered if:</p>
          <ul className="mt-4 list-disc pl-6 text-gray-700 space-y-2">
            <li>Payment was made in error (for example, duplicated payment).</li>
            <li>The booking is cancelled before pickup.</li>
            <li>We are unable to provide the service as booked.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-900">Non-Refundable Situations</h2>
          <p className="mt-3 text-gray-700">Refunds are not provided for:</p>
          <ul className="mt-4 list-disc pl-6 text-gray-700 space-y-2">
            <li>Incorrect or incomplete shipment details provided by the customer.</li>
            <li>Delays, holds, seizures, duties, or additional checks by customs or authorities.</li>
            <li>Shipments refused by the recipient or undeliverable due to address issues.</li>
            <li>Prohibited, restricted, misdeclared, or non-compliant items.</li>
            <li>Any shipment already collected or dispatched.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-900">How Refunds Are Processed</h2>
          <ul className="mt-4 list-disc pl-6 text-gray-700 space-y-2">
            <li>
              Approved refunds are issued to the <strong>original payment method</strong> used for the transaction.
            </li>
            <li>Refunds are processed via Stripe.</li>
            <li>
              Refunds typically take <strong>5–10 working days</strong> to appear in your bank or card statement,
              depending on your bank.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-900">Contact for Refund Requests</h2>
          <p className="mt-3 text-gray-700">
            To request a cancellation (before pickup) or a refund, please email:
          </p>
          <p className="mt-3 text-gray-900 font-semibold">support@sundarbancargo.co.uk</p>
        </section>
      </div>
    </StaticPageLayout>
  );
};

export default RefundCancellationPolicy;


